<template>
	<div id="subpageDiv">
		<div class="subBanner" style="background:url(/images/subBg08.png) center center no-repeat">
		    <div class="w1200">
		        <div class="subTitle">
		            <em>Data Index</em>
		            <span>数据指数</span>
		            <img src="/images/line.png" class="line"/>
		        </div>
		    </div>
		</div>
		<div class="w1200 yuntupage">
			<div class="itemWap">
				<div class="report_nav">
					<dl @click="menuFirstChange(item.tagid,item.tagname)" v-for="(item,index) in menuDataList">
							<dt>{{item.tagname}}<img :src="menuFirst==item.tagid?'/images/dIcon.png':'/images/down.png'" style="float: right;margin: 5px 10px;" /></dt>
							<el-collapse-transition>
								<div v-show="menuFirst==item.tagid">
									<dd v-if="item.children" v-for="(citem,cindex) in item.children">
										<a v-if="citem.children.length>0" @click.stop="menuSecondChange(citem.tagid)" :class="citem.tagid==menuSecond?'on':''" >{{citem.tagname}}</a>
									</dd>
								</div>
							</el-collapse-transition>
					</dl>
				</div>
				<div class="rightMain">
					<div class="righttop" :style="{'max-height':menuMoreVisible?'unset':''}">
						<div class="righttop_left" ref="righttopleftdiv">
							<router-link v-for="(item,index) in menuRight" :to="{ name: 'yuntu', params: { column:item.tagid }}" :class="item.tagid==colid?'on':''" @click.native="$track([['pagetype','数据指数-'+menuFirstName+'-'+menuSecondName+'-'+item.tagname+'-点击']])">{{item.tagname}}</router-link>
						</div>
						<div class="righttop_right" v-if="menuMoreBtnVisible">
							<div v-if="!menuMoreVisible" @click="showmoremenu()"
							 style="position: absolute;display: inline-block;padding: 10px 0px;margin: 2px 0px;right: 0px;bottom: 0px;cursor: pointer;">
								更多<img	src="/images/down.png" />
							</div>
							<div v-else @click="hidemoremenu()"
							 style="position: absolute;display: inline-block;padding: 10px 0px;margin: 2px 0px;right: 0px;bottom: 0px;cursor: pointer;">
								收起<img	src="/images/dIcon.png" />
							</div>
						</div>
					</div>
					<div class="rightbottom">
						<div class="yuntubtns">
							<div class="set">
								<ul>
									<li v-if="hasFavorite=='0'" @click="addfavorite"><img src="/images/flow.png"
											class="flow active" /><span>收藏</span></li>
									<li v-if="hasFavorite=='1'" @click="removefavorite"><img src="/images/flow.png"
											class="flow" /><span>取消收藏</span></li>
									<li @click="tabledownload"><img src="/images/fileDown.png"
											class="fileDown" /><span>下载为Excel格式</span></li>
									<li @click="sharelink"><img src="/images/share.png" class="share" /><span>分享标题和链接</span></li>
								</ul>
							</div>
						</div>
						<yuntutable v-if="tabletype==1" v-bind:colid="colid" ></yuntutable>
						<yuntutablestructure v-else-if="tabletype==0" v-bind:colid="colid" v-bind:tableshowtype="tableshowtype"></yuntutablestructure>
						<div v-if="source" class="yuntunote">
							来源：<br/>
							<p v-html="source?source.replace(/\n/g,'<br />'):''"></p>
						</div>
						<div v-if="note" class="yuntunote">
							注释：<br/>
							<p v-html="note?note.replace(/\n/g,'<br />'):''"></p>
						</div>
						<!-- <div class="yuntunote">
							免责声明：<br/>
							<p>中经网数字中国专版数据指数主要来源于：各级政府部门；时事新闻；国家权威研究机构的研究成果、白皮书、通知声明等。数据指数提供的数据和信息与中经网观点和立场无关。</p>
						</div> -->
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import * as XLSX from 'xlsx'
	import yuntutable from "@/components/yuntu-table.vue"
	import yuntutablestructure from "@/components/yuntu-table-structure.vue"
	export default {
		data() {
			return {
				loadingMask: true,
				colid:'',
				colname:'',
				coltype:0,
				tableshowtype:0,
				note:'',
				source:'',
				hasFavorite:'',
				menuFirst:'',
				menuFirstName:'',
				menuSecond:'',
				menuSecondName:'',
				menuDataList:[],
				menuRight:[],
				resultDataList: [],
				menuMoreBtnVisible:false,
				menuMoreVisible:false,
				// columnList:[
				// 	'8fa48674960d4cb2805a94e6900cfa7e',
				// 	'14905678b7984f5c93420737214da097',
				// 	'f6ef64c2842749388f62da0951d06e69',
				// 	'132f4297260a4045b3ec154f51c208e3',
				// 	'9a77052ea9474b4ca77f95d640debd51',
				// 	'0f12c4cf644c4995b12b7a6d1109415f',
				// ],
			}
		},
		components:{
			yuntutable,
			yuntutablestructure
		},
		created:function(){
			this.colid=this.$route.params.column?this.$route.params.column:'';
			this.getmenufnc();
		},
		mounted:function(){
			document.title='数据-数字中国专版';
			this.getfavorite();
			this.$track([
				['pagetype','数据指数-浏览'],
			]);
			
		},
		watch: {
			$route (to, from) {
				if(to.params.column != from.params.column){
					this.colid=this.$route.params.column?this.$route.params.column:'';
					this.selmenu();
					this.getfavorite();
				}
			}
		},
		methods: {
			jumpto: function(columnid){
				this.$router.push('/yuntu'+(columnid?('/'+columnid):''));
			},
			showmoremenu:function(){
				this.menuMoreVisible=true;
			},
			hidemoremenu:function(){
				this.menuMoreVisible=false;
			},
			menuFirstChange: function(firstid,firstname){
				if(firstid&&this.menuFirst!=firstid){
					this.menuFirst=firstid;
					this.$track([
						['pagetype','数据指数-'+firstname+'-点击'],
					]);
				}
				else{
					this.menuFirst='';
				}
			},
			menuSecondChange: function(secondid){
				if(secondid){
					for(var i=0;i<this.menuDataList.length;i++){
						for(var j=0;j<this.menuDataList[i].children.length;j++){
							if(this.menuDataList[i].children[j].tagid==secondid){
								this.$track([
									['pagetype','数据指数-'+this.menuDataList[i].tagname+'-'+this.menuDataList[i].children[j].tagname+'-点击'],
								]);
								this.jumpto(this.menuDataList[i].children[j].children[0].tagid);
								this.menuMoreVisible=false;
								break;
								// this.menuFirst=this.menuDataList[i].tagid;
								// console.log(this.menuFirst)
							}
						}
					}
				}
			},
			menuThirdChange: function(thirdid){
				if(thirdid){
					this.jumpto(thirdid);
				}
			},
			selmenu:function(){
				for(var i=0;i<this.menuDataList.length;i++){
					for(var j=0;j<this.menuDataList[i].children.length;j++){
						for(var k=0;k<this.menuDataList[i].children[j].children.length;k++){
							if(!this.colid){
								this.colid=this.menuDataList[i].children[j].children[k].tagid;
							}
							if(this.menuDataList[i].children[j].children[k].tagid==this.colid){
								this.colname=this.menuDataList[i].children[j].children[k].tagname;
								this.tabletype=this.menuDataList[i].children[j].children[k].chartType;
								this.tableshowtype=this.menuDataList[i].children[j].children[k].tableShowType;
								this.note=this.menuDataList[i].children[j].children[k].node;
								this.source=this.menuDataList[i].children[j].children[k].exattribute1;
								this.menuRight=this.menuDataList[i].children[j].children;
								this.menuSecond=this.menuDataList[i].children[j].tagid;
								this.menuSecondName=this.menuDataList[i].children[j].tagname;
								this.menuFirst=this.menuDataList[i].tagid;
								this.menuFirstName=this.menuDataList[i].tagname;
								this.$nextTick(function(){
									if(this.$refs.righttopleftdiv.scrollHeight>142){
										this.menuMoreBtnVisible=true;
									}
									else{
										this.menuMoreBtnVisible=false;
									}
								})
								break;
							}
						}
					}
				}
			},
			getmenufnc: function() {
				let _this = this;
				_this.loadingMask = true;
				this.$http({
						method: 'get',
						url: 'szjjchart/selectAllLableChart',
						responseType: 'json',
						params: {
						},
					})
					.then(function(response) {
						// debugger;
						_this.menuDataList = response.data.data.data;
						for(var i=0;i<_this.menuDataList.length;i++){
							for(var j=0;j<_this.menuDataList[i].children.length;j++){
								for(var k=0;k<_this.menuDataList[i].children[j].children.length;k++){
									if(_this.menuDataList[i].children[j].children[k].chartType){
										_this.menuDataList[i].children[j].children[k].tagid=_this.menuDataList[i].children[j].children[k].tagid+'_'+_this.menuDataList[i].children[j].children[k].tagname;
									}
									else{
										_this.menuDataList[i].children[j].children[k].tagid=_this.menuDataList[i].children[j].children[k].parentid+'_'+_this.menuDataList[i].children[j].children[k].tagname;
									}
								}
							}
						}
						_this.selmenu();
						_this.loadingMask = false;
					})
					.catch(function(error) {
						_this.loadingMask = false;
						console.log(error);
					});
			},
			getfavorite: function() {
				let _this = this;
				this.$http({
						method: 'post',
						url: 'UserInfo/isYtFavorites',
						responseType: 'json',
						params: {
							userid: this.$cookies.get('userinfo') ? this.$cookies.get('userinfo').userAccountID:'',
							labelid: this.colid,
						},
					})
					.then(function(response) {
						_this.hasFavorite = response.data.data.data.code=='1'?'1':'0';
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			addfavorite: function() {
				// this.$track([
				// 	['pagetype','数据指数-'+this.menuFirstName+'-'+this.menuSecondName+'-'+this.colname+'-收藏-点击'],
				// ]);
				if (this.$cookies.get('userinfo') && this.$cookies.get('userinfo').userAccountID) {
					let _this = this;
					this.$http({
							method: 'post',
							url: 'UserInfo/AddYtFavorites',
							responseType: 'json',
							params: {
								userid: this.$cookies.get('userinfo').userAccountID,
								labelid: this.colid,
								columnid: this.colname,
								articletype: 5,
								articleid: '0',
							},
						})
						.then(function(response) {
							if (response.data.success) {
								_this.$message({
									message: '收藏成功',
									type: 'success'
								});
								_this.hasFavorite = '1';
								_this.$track([
									['pagetype', '添加收藏'],
									['pageid', _this.colid]
								]);
							}
						})
						.catch(function(error) {
							console.log(error);
						});
				}
			},
			removefavorite: function() {
				// this.$track([
				// 	['pagetype','数据指数-'+this.menuFirstName+'-'+this.menuSecondName+'-'+this.colname+'-取消收藏-点击'],
				// ]);
				if (this.$cookies.get('userinfo') && this.$cookies.get('userinfo').userAccountID) {
					let _this = this;
					this.$http({
							method: 'post',
							url: 'UserInfo/DelYtFavorites',
							responseType: 'json',
							params: {
								userid: this.$cookies.get('userinfo').userAccountID,
								labelid: this.colid
							},
						})
						.then(function(response) {
							if (response.data.success) {
								_this.$message({
									message: '已取消收藏',
									type: 'success'
								});
								_this.hasFavorite = '0';
								_this.$track([
									['pagetype', '删除收藏'],
									['pageid', _this.colid]
								]);
							}
						})
						.catch(function(error) {
							console.log(error);
						});
				}
			},
			tabledownload:function(){
				// this.$track([
				// 	['pagetype','数据指数-'+this.menuFirstName+'-'+this.menuSecondName+'-'+this.colname+'-下载-点击'],
				// ]);
				/* 从表生成工作簿对象 */
				var wb = XLSX.utils.table_to_book(document.querySelector('#filterTable'))
				XLSX.writeFileXLSX(wb, this.colname+".xlsx");
				this.$message({
					message: '稍候将弹出文件保存选项',
					type: 'success'
				});
				this.$track([
					['pagetype', '下载Excel'],
					['pageid',this.colid],
					['tag',this.colname]
				]);
			},
			sharelink: function() {
				// this.$track([
				// 	['pagetype','数据指数-'+this.menuFirstName+'-'+this.menuSecondName+'-'+this.colname+'-分享-点击'],
				// ]);
				var temptext = '';
				temptext += '标题：' + this.colname + '\r\n';
				temptext += '链接：' + window.location.href + '\r\n';
				temptext += '来源：数字中国专版';
				const textarea = document.createElement('textarea'); 
				textarea.value = temptext; 
				document.body.appendChild(textarea);
				textarea.select();
				document.execCommand('Copy');
				document.body.removeChild(textarea);
				this.$track([
					['pagetype', '分享'],
					['pageid',this.colid],
					['tag',this.colname]
				]);
				this.$message({
					message: '分享链接已复制到剪贴板',
					type: 'success'
				});
			}
		}
	}
</script>

<style>
</style>
